// extracted by mini-css-extract-plugin
module.exports = {"favouriteListingsDesktopCarousel":"FavouriteListings_favouriteListingsDesktopCarousel__Y5z8U"};